import React from 'react';

// Components
import Img from 'components/Img';
import CartProduct from 'components/Carts/CartProduct';

// Classes
import clsx from 'clsx';

type CartProductProps = {
	id?: number,
	img?: string,
	cas?: string,
	name?: string,
	virtid?: number,
	smiles?: string,
	details?: string,
	product?: string,
	description?: string,
	ebcId?: string,
	iupacName?: string,
	mw?: string | number,
	logP?: string | number,
	currentWord?: string,
	onStock?: boolean,
	drugsImpurities?: any,
}

interface IList {
	type?: string;
	currentValue?: string;
	data?: CartProductProps[];
}

export const List: React.FC<IList> = (props) => {
	const {
		data,
		type,
		currentValue
	} = props;
	const cn = clsx(
		data?.length ? '' : 'search-screen__list--active',
		'search-screen__list-not-found'
	);

	if (!data?.length) {
		return <div className={cn}>
			<Img
				alt="Empty icon"
				name="searchEmpty"
				className="search-screen__empty-icon"
			/>
			<p className="search-screen__empty-text">
				We didn't find any {type === 'compounds' ? 'compound' : 'linkers'}
			</p>
		</div>;
	}

	const filteredDataByOnStock = data?.length
		? [...data]?.sort((a: any, b: any) => b.onStock - a.onStock)
		: [];

	return (
		<div className="search-screen__list">
			{!!filteredDataByOnStock?.length && filteredDataByOnStock.map((item: CartProductProps, i: number) => {
				const isFirst = i === 0;
				const uniqId = isFirst ? 'structure-search-id' : '';
				const uniqIdControl= isFirst ? 'structure-search-control' : '';
				const uniqIdAddProject= isFirst ? 'structure-search-add-project' : '';

					return <CartProduct
						{...item}
						type={type}
						currentValue={currentValue}
						key={`${item.virtid}__${i}`}

						uniqId={uniqId}
						uniqIdControl={uniqIdControl}
						uniqIdAddProject={uniqIdAddProject}
					/>;
				}
			)}
		</div>
	);
};

export default List;
